export default __webpack_public_path__ + "static/media/design.8db989ee.svg";